import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '@repo/common';

const RESUME_BUILDER_PATH = '/career/resumes/new?source=career_my_resumes_empty';

// 다른 Empty* 컴포넌트와 같은 레이아웃. 높이는 커리어 페이지 ResumeCard 와 같게 맞춰 카드 유무로 섹션 높이가 바뀌지 않게 한다.
// 설명 문구의 Create 만 이력서 빌더로 링크한다
const EmptyResume = () => {
  const t = useT();
  const createLink = (label) => (
    <Link
      to={RESUME_BUILDER_PATH}
      className='text-green-deep03 underline underline-offset-2 hover:text-green-deep04'
    >
      {label}
    </Link>
  );

  return (
    <div className='flex flex-col justify-center items-center gap-1 w-full tabletH:p-10 h-[283px] tabletH:h-[480px] text-center'>
      <div className='typo-b14Strong text-text-secondary'>
        {t('No resumes yet', '아직 이력서가 없습니다')}
      </div>
      <div className='typo-b14 text-text-placeholder'>
        {t(
          <>{createLink('Create')} your first resume to get started.</>,
          <>첫 이력서를 {createLink('만들고')} 시작해 보세요.</>,
        )}
      </div>
    </div>
  );
};

export default EmptyResume;
